import { MARK_COLOR } from '@udecode/plate-font';

export const COLOR_PLUGIN_KEY = MARK_COLOR;

export const defaultColorsConfig = ['var(--uui-text-critical)', 'var(--uui-text-warning)', 'var(--uui-text-success)'];
